import { Link } from "react-router-dom";
import classNames from "classnames";
import classes from "./NavItem.module.css";

const NavItem = (props) => {
  const { to, children } = props;
  return (
    <Link
      to={to}
      className={classNames("flex items-center", classes["nav-item"])}
    >
      {children}
    </Link>
  );
};

export default NavItem;
